import { Button } from "primereact/button";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function TopBar() {
    const navigate = useNavigate();
    const location = useLocation();
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

    const goToSection = (sectionId: string) => {
        if (location.pathname === "/") {
            const el = document.getElementById(sectionId);
            if (el) {
                const offset = 400;
                const top = el.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top, behavior: "smooth" });
            }
        } else {
            navigate("/", { state: { scrollTo: sectionId } });
        }
    };

    const goHome = () => {
        if (location.pathname === "/") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            navigate("/");
        }
    };

    return (
        <div className="p-2 shadow-1 bg-white" style={{ position: 'sticky', top: 0, zIndex: 1000 }}>
            <div className="flex align-items-center justify-content-between gap-3">
                <div>
                    <img
                        src="/images/logo1.png"
                        alt="Green Blend Logo"
                        className="h-4rem"
                        style={{ cursor: 'pointer' }}
                        onClick={goHome}
                    />
                </div>
                <div className="hidden md:flex gap-6 align-items-center">
                    <span onClick={goHome} className="text-6 font-bold cursor-pointer">
                        Home
                    </span>
                    <span onClick={() => goToSection('coconutoil')} className="text-6 font-bold cursor-pointer">
                        Coconut Oil Products
                    </span>
                    <span onClick={() => goToSection('stringhoppers')} className="text-6 font-bold cursor-pointer">
                        String Hoppers Products
                    </span>
                    <span onClick={() => goToSection('benefits')} className="text-6 font-bold cursor-pointer">
                        Benefits
                    </span>
                </div>

                <div className="hidden md:block">
                    <Button
                        label="Contact Us"
                        className="button btn-1-r"
                        onClick={() => goToSection('contactus')}
                    />
                </div>

                <div className="md:hidden">
                    <Button
                        icon="pi pi-bars"
                        className="p-button-text p-button-rounded"
                        onClick={() => setMobileMenuVisible(!mobileMenuVisible)}
                    />
                </div>
            </div>

            {mobileMenuVisible && (
                <div className="flex flex-column gap-4 p-4 surface-0 shadow-2 md:hidden animate__animated animate__fadeInDown">
                    <span onClick={() => { goHome(); setMobileMenuVisible(false); }} className="text-lg cursor-pointer">
                        Home
                    </span>
                    <span onClick={() => { goToSection('coconutoil'); setMobileMenuVisible(false); }} className="text-lg cursor-pointer">
                        Coconut Oil Products
                    </span>
                    <span onClick={() => { goToSection('stringhoppers'); setMobileMenuVisible(false); }} className="text-lg cursor-pointer">
                        String Hoppers Products
                    </span>
                    <span onClick={() => { goToSection('benefits'); setMobileMenuVisible(false); }} className="text-lg cursor-pointer">
                        Benefits
                    </span>
                    <Button
                        label="Contact Us"
                        className="button btn-1-r w-full"
                        onClick={() => { goToSection('contactus'); setMobileMenuVisible(false); }}
                    />
                </div>
            )}
        </div>
    );
}